import { SessionState, useMSAL } from "render/context/MSALContext";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { LogoHeader } from "render/ui/layout/LogoHeader";
import { PageFrame } from "render/ui/layout/PageFrame";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";

export function LoginView() {
  const { auth, session } = useMSAL();

  const busy = session.state !== SessionState.Settled;

  const canLogin = !auth && !busy;

  return (
    <PageFrame head={<LogoHeader />}>
      <PageFrameContent>
        <InformationLayout
          content={
            <Typography variant="display-s" color="default">
              Please sign in to start
            </Typography>
          }
          buttons={
            <Button
              onPress={session.logIn}
              state={!canLogin ? "disabled" : undefined}
              fillContainer
              icon={<Icon24ArrowRight />}
            >
              Sign in
            </Button>
          }
        />
      </PageFrameContent>
    </PageFrame>
  );
}
